import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyContent"] */ "/app/src/app/(frontend)/privacy-policy/PrivacyPolicyContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContentClient"] */ "/app/src/components/frontend/PageContentClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RedStatisticsBand"] */ "/app/src/components/frontend/RedStatisticsBand.tsx");
